<template>
  <fullscreen-view class="email-selection">
    <template #header>
      <button class="button cancel-button" @click="$emit('closeEmailTemplateSelectionModal')">cancel</button>
      <span v-if="error" class="error">{{ error }}</span>
      <button class="button blank-template-button" @click="$emit('openEmailCreationModalAndSetTemplate', { layout_json: '{}' })">new template</button>
    </template>
    <template #content>
      <simple-modal
        v-if="templateToDelete"
        class="template-delete-modal"
        title="are you sure you want to delete this template?"
        @rejected="templateToDelete = null"
      >
        <template slot="buttons">
          <button class="sb-button" @click="deleteEmailTemplate()">delete</button>
        </template>
      </simple-modal>

      <div class="text-message">create a new template or select from one of the options below</div>
      <div class="template-tile-wrapper">
        <div v-for="(template, index) in email.specific_merchant_templates" :key="`merchant-${index}`" class="template-tile">
          <div class="template-title">{{template.title}}</div>
          <div class="select-template merchant-list">
            <a @click="$emit('openEmailCreationModalAndSetTemplate', template)">
              <template v-if="template.preview_image">
                <img :src="template.preview_image" :alt="template.title" />
              </template>
              <template v-else>
                <div style="align-self: center; text-align: center">
                  <span class="negative">generating template please wait...</span>
                </div>
              </template>
            </a>
          </div>
          <div class="delete-button-wrapper">
            <a @click="templateToDelete = template" class="delete-button">
              delete
            </a>
          </div>
        </div>
        <div v-for="(template, index) in email.global_templates" :key="`global-${index}`" class="template-tile">
          <div class="template-title">{{template.title}}</div>
          <div class="select-template global-list">
            <a @click="$emit('openEmailCreationModalAndSetTemplate', template)">
              <template v-if="template.preview_image">
                <img :src="template.preview_image" :alt="template.title" />
              </template>
              <template v-else>
                <div style="align-self: center; text-align: center">
                  <span class="negative">generating template please wait...</span>
                </div>
              </template>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #footer></template>
  </fullscreen-view>
</template>

<script>
import { FullscreenView, SimpleModal } from "@springbig/sb-components";
import { beeAPI } from "../../../services/api/beeAPI.js";

export default {
  props: {
    email: Object
  },

  name:"email-template-selection",

  components: {FullscreenView, SimpleModal},

  data() {
      return {
        error: null,
        templateToDelete: null
      }
    },

  methods: {
    async deleteEmailTemplate() {
      this.error = null;
      try {
        const resp = await beeAPI.deleteEmailTemplate(this.templateToDelete?.id);
        this.templateToDelete = null;
        if(resp.status !== 200){
          this.error = 'an unexpected error occurred! template was not correctly deleted';
          return
        };
        this.$emit('refreshTemplateList');
      } catch (e) {
        this.error = "an unexpected error occurred! if this keeps happening please contact us at support@springbig.com"
      };
    }
  }

}
</script>

<style scoped>
.email-selection {
  display: flex;
  flex-direction: column;
}

.email-selection >>> header {
  align-items: center;
  background-color: #128ff933;
  display: flex;
  flex-direction: row;
  justify-content: space-between !important;
  height: 81px;
  padding: 0 1.5rem !important;
}

.email-selection >>> .button.cancel-button {
  background-color: transparent;
  color: #128ff9;
  font-family: "AileronThin";
  font-size: 18px;
  height: 58px;
  line-height: 1em;
  margin: 15px 30px 15px 0;
}

.email-selection >>> .button.blank-template-button {
  font-family: "AileronThin";
  font-size: larger;
  line-height: 1em;
  margin: 15px 30px 15px 0;
  padding: 0.85rem 0.6rem;
}

.email-selection >>> .button.design-button {
  font-family: "AileronThin";
}

.email-selection >>> .content>.template-tile-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  overflow-y: auto;
  padding: 15px;
  width: 100%;
}

.email-selection .negative {
  color: #a4a4a4;
}

.email-selection .bolder {
  font-weight: 700;
}

.email-selection .pb-15 {
  padding-bottom: 15px;
}

.email-selection >>> .content {
  overflow: auto;
  height: 100%;
}

.email-selection >>> .select-template {
  align-items: center;
  border-radius: 8px;
  border: 1px solid #128ff9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 8px;
  height: 200px;
  padding: 15px;
  width: 200px;
  overflow: auto;
}

.email-selection >>> .select-template:hover {
  border-color: #016fb9;
}

.email-selection >>> .select-template.merchant-list {
  margin-bottom: 0;
}

.email-selection >>> .select-template a {
  align-items: start;
  display: flex;
  height: 100%;
}

.email-selection >>> .select-template img {
  height: auto;
}

.email-selection >>> .delete-button-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.email-selection >>> .global-list {
  margin-bottom: 43px;
}

.email-selection >>> .delete-button {
  color: #888;
}

.email-selection >>> .text-message {
  font-size: 25px;
  margin-bottom: 20px;
  margin-top: 30px;
  text-align: center;
}

.email-selection >>> .template-title {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  max-height: 3em;
  line-height: 1.5em;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: normal;
  width: 200px;
}

.email-selection >>> .template-tile {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.template-delete-modal>div {
  width: 35%;
}

.template-delete-modal >>> header {
  background-color: transparent;
}

.template-delete-modal >>> header>div {
  width: 70%;
  text-align: center;
  margin: auto;
}

.template-delete-modal >>> .content {
  display: none;
}
</style>